import { render, staticRenderFns } from "./ConfirmIsOrderModal.vue?vue&type=template&id=5472bbc2&scoped=true"
import script from "./ConfirmIsOrderModal.vue?vue&type=script&lang=js"
export * from "./ConfirmIsOrderModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmIsOrderModal.vue?vue&type=style&index=0&id=5472bbc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472bbc2",
  null
  
)

export default component.exports